export const c_calendar_month__dates_cell_m_in_range_m_end_range_before_Right = {
  "name": "--pf-c-calendar-month__dates-cell--m-in-range--m-end-range--before--Right",
  "value": "50%",
  "var": "var(--pf-c-calendar-month__dates-cell--m-in-range--m-end-range--before--Right)"
};
export default c_calendar_month__dates_cell_m_in_range_m_end_range_before_Right;